export default function clearCameras(state, action) {
  return (
    Object.assign({}, state, {
      cameras: [],
      currentEntity: { type: 'map' }
    })
  )
}



// WEBPACK FOOTER //
// ./src/reducers/clearCameras.js